import moment from 'moment';

const formatDate = (args) => {
  const { actions, data, defaultReturn, options } = args;
  let ret = defaultReturn ? defaultReturn : '';
  let date = data;
  if (!Boolean(data)) {
    return ret;
  }

  if (Array.isArray(options)) {
    if (options?.includes('append-timezone')) date = `${date}T00:00:00`;
  }

  if (actions.includes('excel')) {
    ret = moment(date).format('YYYY-MM-DD');
  } else if (actions.includes('fileName')) {
    ret = moment(date).format('YYYYMMDD');
  } else if (actions.includes('expiration')) {
    ret = moment(date).format('MM/YY');
  } else if (actions.includes('display+time')) {
    ret = moment(date).format('MMM DD yyyy hh:mm:ss a');
  } else if (actions.includes('display')) {
    ret = moment(date).format('MMM DD, yyyy');
  } else if (actions.includes('month-day')) {
    ret = moment(date).format('MMM DD');
  } else if (actions.includes('mysql')) {
    ret = moment(date).format('YYYY-MM-DD');
  } else if (actions.includes('ts')) {
    ret = moment(date).toDate().getTime();
  } else if (actions.includes('new-date-object')) {
    ret = new Date(date);
    if (options?.includes('set-date-zero')) ret = new Date(ret.setUTCHours(0, 0, 0, 0));
  }

  if (ret === 'Invalid date') ret = defaultReturn || 'Invalid Date';

  return ret;
};

export default formatDate;
